import { Gauge, ShieldAlert } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const fmeaNav: NavEntry = {
  label: 'Failure risk analysis',
  icon: ShieldAlert,
  path: '/quality/fmea',
  permission: 'risk:read',
  order: 18,
}
export const riskRegisterNav: NavEntry = {
  label: 'Risk register',
  icon: Gauge,
  path: '/quality/risks',
  permission: 'risk:read',
  order: 19,
}
